export const getUserToken = (establishmentId: string, userEmail: string) =>
  localStorage.getItem(`userToken_${establishmentId}_${userEmail}`)

export const setUserToken = (establishmentId: string, token: string, userEmail: string) =>
  localStorage.setItem(`userToken_${establishmentId}_${userEmail}`, token)

export const removeUserToken = (establishmentId: string, userEmail: string) =>
  localStorage.removeItem(`userToken_${establishmentId}_${userEmail}`)